import { UtilService } from './util.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CurrentUser } from '../model/current-user';
import { GlobalData } from '../globalData';
import * as _ from 'underscore';
import { Router } from '@angular/router';
import { AppConstants } from 'app/app.constants';
@Injectable()
export class AuthInterceptor {

  constructor(private utilService: UtilService, private router: Router) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.utilService.buttonDisableObservable.next(true);
    let apiUrl = environment.apiUrl + req.urlWithParams;

    // Local bundle assets must NEVER be rewritten to the API server. This has
    // to run BEFORE the SHIVAM branch: on portal routes the panchang.json
    // fetch used to be sent to the backend with the devotee token, and every
    // continuous-booking open toasted a 403 "no permission".
    if (req.urlWithParams.includes('assets/json/panchang.json')) {
      return next.handle(req.clone({ url: req.urlWithParams }));
    }

    if (AppConstants.isShivamRoute(this.router.url)) {
      // SHIVAM LOGIC START
      const usr = localStorage.getItem('currentUser');
      const currentUser: any = !!usr ? JSON.parse(usr) : null;
      const token = !!currentUser ? currentUser.accessToken : null;
      const tuid = localStorage.getItem('tuid');
      let headers = req.headers;
      if (tuid !== null && tuid !== "null") {
        headers = headers.set('tuid', tuid);
        // apiUrl = apiUrl + '/' + tuid; // Removed as per requested move to header
      }
      if (!!token && req.urlWithParams !== 'temple/pooja/online' && req.urlWithParams !== 'all'
        && req.urlWithParams !== 'user/login/online' && req.urlWithParams !== 'login/socialmedia/online'
        && req.urlWithParams !== 'signup/online'
        && req.urlWithParams !== 'signup/socialmedia/online' && req.urlWithParams !== 'user/exist/online') {
        const authReq = req.clone({ headers: headers.set('Authorization', 'Bearer ' + token), url: apiUrl });
        return next.handle(authReq);
      } else {
        const request = req.clone({ url: apiUrl, headers: headers });
        return next.handle(request);
      }
    }

    const tuid = localStorage.getItem('tuid');
    let headers = req.headers;
    if (tuid !== null && tuid !== "null") {
      headers = headers.set('tuid', tuid);
    }

    const currentApi = _.find(GlobalData.menus, menu => menu.api === req.urlWithParams);
    if (!!currentApi) {
      if (!currentApi.array.length) {
        const user = sessionStorage.getItem('CURRENT_USER');
        const crntUser: CurrentUser = !!user ? JSON.parse(user) : null;
        const tokeN = !!crntUser ? crntUser.accessToken : null;
        if (!!tokeN) {
          const authReq = req.clone({ headers: headers.set('Authorization', 'Bearer ' + tokeN), url: apiUrl });
          return next.handle(authReq);
        }
      }
      if (!!currentApi.array.length) {
        this.utilService.buttonDisableObservable.next(false);
        return;
      }
      return;
    }
    else {
      // if (!req.params.has('permit')) {
      const usr = sessionStorage.getItem('CURRENT_USER');
      const currentUser: CurrentUser = !!usr ? JSON.parse(usr) : null;

      const token = !!currentUser ? currentUser.accessToken : null;
      if (!!token) {
        // Clone the request to add the new header.
        const authReq = req.clone({ headers: headers.set('Authorization', 'Bearer ' + token), url: apiUrl });
        // const authReq = req.clone({ setHeaders: { 'Authorization': 'Bearer ' + token }, url: apiUrl });
        // Pass on the cloned request instead of the original request.
        return next.handle(authReq);
      }
    }
    // }
    req.params.delete('permit', 'false');
    const anonymousReq = req.clone({ url: apiUrl, headers: headers });
    return next.handle(anonymousReq);
  }

}
